import {Modal, Button} from 'components/ui';
import {useMobile} from 'utils/hooks';
import styles from './FocusModeLogoutModal.module.scss';

interface FocusModeLogoutModalProps {
  focusModeClosedCount: number;
  onContinue: () => void;
  onConfirmLogout: () => void;
}

function ordinalFeminine(n: number): string {
  return `${n}ª`;
}

function FocusModeLogoutModal({
  focusModeClosedCount,
  onContinue,
  onConfirmLogout,
}: FocusModeLogoutModalProps): JSX.Element {
  const {isMobile} = useMobile();
  const nextCount = focusModeClosedCount + 1;

  return (
    <Modal
      isOpen
      onClose={onContinue}
      clickOutsideToClose={false}
      buttonClose={false}
      minWidth={isMobile ? undefined : 500}
      maxWidth={isMobile ? 360 : 500}
      vw={isMobile ? 94 : 90}
    >
      <div className={styles.container}>
        <p className={styles.message}>
          Você está saindo de uma atividade em Modo Foco.
          <br />
          Esta será a sua <strong>{ordinalFeminine(nextCount)} saída</strong> de
          no máximo 10.
          <br />
          Você tem até 10 minutos para voltar. Se ultrapassar esse limite ou
          atingir 10 saídas, a atividade é encerrada e os dados não são
          enviados.
        </p>
        <div className={styles.actions}>
          <Button
            text="Voltar para a atividade"
            variant="secondary"
            onClick={onContinue}
          />
          <Button
            text="Sair mesmo assim"
            variant="primary"
            onClick={onConfirmLogout}
          />
        </div>
      </div>
    </Modal>
  );
}

export default FocusModeLogoutModal;
